<script>
    import IconCancel from "../icons/IconCancel.svelte";

    export let onClick;
</script>

<button on:click|preventDefault={onClick} class="multistep-form-cancel">
    <IconCancel />
</button>
